import { api } from './api';

export const downloadService = {
  // Download a single mockup file
  async downloadMockup(
    mockupId: string, 
    filename: string, 
    format: 'png' | 'jpg' = 'png',
    resolution: 'web' | 'print' = 'web'
  ): Promise<void> {
    try {
      // Request the file from the backend
      const response = await api.get(`/api/download/${mockupId}/${format}`, {
        params: { resolution },
        responseType: 'blob'
      });
      
      // Create a blob URL
      const blob = new Blob([response.data], { 
        type: format === 'png' ? 'image/png' : 'image/jpeg' 
      });
      const url = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = filename.replace(/\.(png|jpg|jpeg)$/i, `.${format}`);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log(`Downloaded ${filename} as ${format}`);
    } catch (error) {
      console.error('Download failed:', error);
      throw new Error('Failed to download mockup. Please try again.');
    }
  },
  
  // Download multiple mockups as a ZIP file
  async downloadBatch(mockupIds: string[], format: 'png' | 'jpg' = 'png'): Promise<void> {
    try {
      const response = await api.post('/api/download/batch', 
        { mockupIds, format },
        { responseType: 'blob' }
      );
      
      // Create blob and download
      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = `mockups-${new Date().getTime()}.zip`;
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log('Downloaded batch mockups as ZIP');
    } catch (error) {
      console.error('Batch download failed:', error);
      throw new Error('Failed to download mockups. Please try again.');
    }
  }
};